<template>
    <div class="nc-perm">
        <!-- Denied: browser blocked, manual action needed -->
        <template v-if="isDenied">
            <div class="nc-perm__icon nc-perm__icon_warn">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                    <path d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
                </svg>
            </div>
            <p class="nc-perm__title">Уведомления заблокированы</p>
            <p class="nc-perm__text">
                Чтобы начать работу с чатами, необходимо разрешить уведомления.<br><br>
                Нажмите на иконку замка <strong>🔒</strong> в адресной строке браузера и разрешите уведомления для этого сайта.
            </p>
        </template>

        <!-- Default: ask for permission -->
        <template v-else>
            <div class="nc-perm__icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                    <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 01-3.46 0"/>
                </svg>
            </div>
            <p class="nc-perm__title">Разрешите уведомления</p>
            <p class="nc-perm__text">
                Чтобы получать сообщения от клиентов в реальном времени, необходимо разрешить уведомления браузера.
            </p>
            <button
                type="button"
                class="nc-perm__btn"
                :disabled="requesting"
                @click="handleAllow"
            >
                {{ requesting ? 'Ожидаем...' : 'Разрешить уведомления' }}
            </button>
        </template>
    </div>
</template>

<script>
import { requestPermissionAndRegister } from '../services/fcm'
import { mapGetters } from 'vuex'

export default {
    name: 'NewChatPermissionBanner',
    data() {
        return { requesting: false }
    },
    computed: {
        ...mapGetters('newChat', ['fcmPermission']),
        isDenied() {
            return this.fcmPermission === 'denied'
        },
    },
    methods: {
        async handleAllow() {
            this.requesting = true
            await requestPermissionAndRegister()
            this.requesting = false
        },
    },
}
</script>

<style lang="scss">
@import '../../../../../gulp-src/app/scss/_variables';

.nc-perm {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 32px 24px;
    gap: 12px;
    height: 100%;

    &__icon {
        width: 56px;
        height: 56px;
        border-radius: 50%;
        background: rgba($global-purple, 0.1);
        color: $global-purple;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 4px;

        &_warn {
            background: rgba(#e94a4a, 0.1);
            color: #e94a4a;
        }
    }

    &__title {
        font-size: 15px;
        font-weight: 600;
        color: $global-black;
        margin: 0;
    }

    &__text {
        font-size: 13px;
        line-height: 1.5;
        color: $global-gray;
        margin: 0;
    }

    &__btn {
        margin-top: 4px;
        padding: 9px 20px;
        border: none;
        border-radius: 8px;
        background: $global-dark-3a;
        color: $global-white;
        font-size: 13px;
        font-weight: 500;
        cursor: pointer;
        transition: opacity 0.15s ease;

        &:disabled {
            opacity: 0.6;
            cursor: default;
        }

        &:not(:disabled):hover {
            opacity: 0.85;
        }
    }
}
</style>